<p>stripe works!</p>
<input type="text" name="ccv" ng2TelInput required />
<div *ngIf="invalidError" style="color: red">
  {{ invalidError.message }}
</div>

<div class="content_text">
  <div class="content_box">
    <stripe-card
      #stripeCard
      (catch)="onStripeError($event)"
      [(invalid)]="invalidError"
      (cardMounted)="(cardReady)"
      (tokenChange)="setStripeToken($event)"
      (sourceChange)="setStripeSource($event)"
    ></stripe-card>
    <button type="button" (click)="stripeCard.createToken(extraData)">
      createToken
    </button>

    <!-- <stripe-source #stripeSource
          (catch)     = "$event"
          [(source)]  = "source"
          [(invalid)] = "invalidError"
        ></stripe-source> 
        
        <button type="button" (click)="stripeSource.createSource()">createSource</button>
      -->
  </div>
</div>
